import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Animated background gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-background to-background pointer-events-none" />
        
        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="animate-fade-in space-y-6 max-w-3xl mx-auto">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight">
              <span className="block text-foreground">Creator-Focused.</span>
              <span className="block text-primary neon-glow">Fan-Funded.</span>
              <span className="block text-foreground">Future-Ready.</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              FANZ is building a next-generation creator-first platform network where consumers fund the platform, not the creators. Creators keep 100% of earnings.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
              <Button size="lg" className="neon-glow">
                Download Investor Brief
              </Button>
              <Button size="lg" variant="outline">
                View Pitch Deck
              </Button>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDown className="w-6 h-6 text-primary animate-glow-pulse" />
        </div>
      </section>

      {/* Key Highlights Bar */}
      <section className="relative py-16 sm:py-20 border-y border-border bg-secondary/30">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { label: "Platforms", value: "3" },
              { label: "Creators", value: "5K+" },
              { label: "Monthly Growth", value: "25%" },
              { label: "Market Size", value: "$64B" },
            ].map((stat, idx) => (
              <div key={idx} className="text-center animate-slide-up" style={{ animationDelay: `${idx * 100}ms` }}>
                <div className="text-3xl sm:text-4xl font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-sm sm:text-base text-muted-foreground">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
